import { useCallback, useEffect, useRef } from "react";

/** Capture ownership before async recovery; URL changes and unmount revoke it. */
export function useArtworkRecovery(url?: string) {
  const generation = useRef(0);
  useEffect(
    () => () => {
      generation.current += 1;
    },
    [url],
  );
  return useCallback(() => {
    const captured = generation.current;
    return () => generation.current === captured;
  }, []);
}

export const shouldRetryRemoteArtworkWithoutDiskCache = (error?: string) => {
  const message = error?.toLowerCase() ?? "";

  if (
    message.includes("404") ||
    message.includes("not found") ||
    message.includes("cancelled")
  ) {
    return false;
  }

  return (
    message.includes("file is directory") ||
    message.includes("is a directory") ||
    message.includes("timed out") ||
    message.includes("network connection was lost") ||
    message.includes("failed to load image") ||
    message.includes("cannot open") ||
    message.includes("couldn't be opened")
  );
};

export const getNextArtworkFallbackUrl = (url?: string | null) => {
  if (!url || url.includes("file")) return null;

  const [rawUrl, imgSize] = url.split("_size=");

  switch (imgSize) {
    case "1024":
      return `${rawUrl}_size=512`;
    case "512":
      return `${rawUrl}_size=256`;
    case "256":
      return `${rawUrl}_size=128`;
    default:
      return null;
  }
};
